import { CountryDateFormatter } from 'src/app/_constants/country_date_formatter';
import { CountryTimeFormatter } from 'src/app/_constants/country_time_formatter';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectLanguagesService } from '../services/select-languages.service';
import { FeedbackService } from './feedback.service';
import { Title } from '@angular/platform-browser';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl, ValidatorFn } from '@angular/forms';
import { FormType } from 'src/app/enums/form-type.enum';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss']
})
export class FeedbackFormComponent implements OnInit, OnDestroy {

  feedbackForm: FormGroup;
  submitted: boolean;
  disabled: boolean = false;
  announcementStatus: boolean = false;
  feedbackPerson: string = "";
  data: any = {};
  ratingId: any = "5";
  ratingArray: Array<number> = [];
  feedbackAllowed : boolean;
  linkExpired: boolean = false;
  public notifier = new Subject();
  formTypes = FormType;

  countryDateFormatter = CountryDateFormatter;
  countryTimeFormatter = CountryTimeFormatter;


  constructor(
    private _formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute, 
    private _feedbackService: FeedbackService, 
    private _router: Router,
    private translate: TranslateService,
    private _selectLanguagesService: SelectLanguagesService,
    private _titleService: Title
    ) {
      this.feedbackForm = _formBuilder.group({
        feedbackChecks: new FormGroup({
          checkbox1: new FormControl(false),
          checkbox2: new FormControl(false),
          checkbox3: new FormControl(false),
          checkbox4: new FormControl(false),
          checkbox5: new FormControl(false),
          checkbox6: new FormControl(false),
          checkbox7: new FormControl(false),
          checkbox8: new FormControl(false),
          checkbox9: new FormControl(false),
          checkbox10: new FormControl(false),
          checkbox11: new FormControl(false),
          checkbox12: new FormControl(false),
          checkbox13: new FormControl(false)
        }, OneCheckboxCheckedValidator()),
      })
    }

  ngOnInit(): void {
    this._selectLanguagesService.getSelectedLanguageObs().pipe(takeUntil(this.notifier)).subscribe(language => {
      this.translate.use(language);
    });
    this._activatedRoute.queryParams.subscribe(params => {
      this.feedbackPerson = params['person'];
      this.data['id'] = params['id'];
      this.data['date'] = params['date'];
      this.data['timezoneDescription'] = params['timezoneDescription'];
      this.data['timezoneAbbreviation'] = params['timezoneAbbreviation'];
      this.data['event'] = params['event'];
      this.data['requestType'] = params['requestType'];
      this.data['utcOffset'] = params['utcOffset'];
      this.data['countryId'] = params['countryId'];
      this.data['serviceSource'] = params['serviceSource'];
      this.data['servicePurpose'] = params['servicePurpose'];
      this.data['storeName'] = params['storeName'];
      this.data['requestTypeId'] = params['requestTypeId'];
    })
    this._titleService.setTitle(this.feedbackPerson + ' Feedback - ASL Services');
    this.feedbackAllowed=false;
    const today= new Date();
    const appDate= new Date(this.data.date);
    const expDate= new Date(new Date(this.data.date).setDate(appDate.getDate() + 10));
    let offset = today.getTimezoneOffset();
    // Set to UTC, Check if DST is observed if so add the hour required
    if (this.isDSTObserved(today)) {
      offset += 60
    }
    today.setTime(today.getTime() + offset * 60000);
    if (today > appDate) {
      this.feedbackAllowed = true;
      if (today > expDate) {
        this.linkExpired = true;
      }
    }
  }

  private stdTimezoneOffset(date: Date):number {
    // Get the standard timezone offset
    var jan = new Date(date.getFullYear(), 0, 1);
    var july = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), july.getTimezoneOffset());
  }

  private isDSTObserved(date: Date): boolean {
    // If the current timezone offset is less than standard then it is in DST
    return date.getTimezoneOffset() < this.stdTimezoneOffset(date);
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  updateRating(event: any) {
    if (event.currentTarget.checked) {
      this.ratingArray.push(parseInt(event.currentTarget.value));
    } else {
      this.ratingArray.splice(this.ratingArray.indexOf(event.currentTarget.value), 1);
    }
  }

  public getHiddenState(control: AbstractControl): boolean {
    return (!this.submitted || !control.errors);
  }

  public formatOffset(offset) {
    var sign = offset < 0 ? "-" : "+";
    var hr = Math.floor(Math.abs(offset));
    var min = Math.floor((Math.abs(offset) * 60) % 60);
    return sign + (hr < 10 ? "0" : "") + hr + ":" + (min < 10 ? "0" : "") + min;
  }

  SubmitFeedback() {
    this.submitted = true;
    if (this.ratingId > 3) {
      this.ratingArray = [];
      this.ratingArray.push(parseInt(this.ratingId));

      if (this.feedbackPerson == 'Interpreter') {
        this._feedbackService.saveInterpreterFeedback(this.data['id'], this.ratingArray)
          .then(response => {
            this._router.navigate(['feedback-form-submitted']);
          }).catch(err => {
          })
      } else {
        if (this.feedbackPerson == 'Scheduler') {
          this._feedbackService.saveSchedulerFeedback(this.data['id'], this.ratingArray)
            .then(response => {
              this._router.navigate(['feedback-form-submitted']);
            }).catch(err => {
            })
        }
      }
    } else if(this.feedbackForm.valid){
      this.disabled = true
        this.ratingArray.push(parseInt(this.ratingId));
        if (this.feedbackPerson == 'Interpreter') {
          this._feedbackService.saveInterpreterFeedback(this.data['id'], this.ratingArray)
            .then(response => {
              this._router.navigate(['feedback-form-submitted']);
            }).catch(err => {
            })
        } else {
          if (this.feedbackPerson == 'Scheduler') {
            this._feedbackService.saveSchedulerFeedback(this.data['id'], this.ratingArray)
              .then(response => {
                this._router.navigate(['feedback-form-submitted']);
              }).catch(err => {
              })
          }
        }
      }
      else{
        this.announcementStatus = true;
        setTimeout(()=>{
          document.getElementById('global-warn').focus();
        },0);
        this.disabled = false;
      }
  }
}

export function OneCheckboxCheckedValidator(minRequired = 1): ValidatorFn {
  return function validate (formGroup: FormGroup) {
    let checked = 0;
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      if (control.value === true) {
        checked ++;
      }
    });
    if (checked < minRequired) {
      return {
        requireOneCheckboxToBeChecked: true,
      };
    }
    return null;
  };
}
